import React from 'react'
import TopHeader from '../Header/TopHeader'
import Navbar from '../Header/Navbar'
import Crousel from '../Screens/Crousel'
import IncomeTaxReturn from '../Screens/IncomeTaxReturn'
import MapBanner from '../Screens/MapBanner'
import Banner from '../Screens/Banner'
import PopularService from '../Screens/PopularService'
import Footer from '../Footer/Footer'
import { Helmet } from 'react-helmet-async'
import PopularGuide from '../Screens/PopularGuide'
import TaxServices from '../Screens/TaxServices'
import WhyChooseUs from '../Screens/WhyChooseUs'
function Main() {
  return (
    <>
      <Helmet>
        <title>Compliancekare | GST Services | ITR Filing| CA Firm| Company Registration| PF ESI Services</title>
        <meta name="description" content="Your trusted Chartered Accountant partner for GST, Income Tax, company incorporation, and statutory compliance — backed by insightful financial reports that drive smarter business decisions." />
        <meta name="keywords" content="GST Consultant| Income Tax Filing |Startup Registration |Financial Reports |Company Registration |PF ESI Services |Tally Accounting |Tax Consultant |CA Firm" />
      </Helmet>
      <TopHeader />
      <Navbar />
      <Crousel />
      <MapBanner />
      <PopularGuide/>
      <TaxServices/>
      <WhyChooseUs/>
     
      <Footer />

    </>
  )
}

export default Main